/**
 * Shared PFM node report standards (keep in sync with EAD-agent projects/pfm_node_report_standard.py).
 */

/** When features, test cases, and procedure steps are not verified yet for this node. */
export const PFM_NODE_REPORT_EXPLORATION_NEEDED_MSG =
  "More exploration is needed for a complete EAD report for this PFM node.";

export function isIncompleteExplorationNodeReportMarkdown(markdown: string): boolean {
  const text = String(markdown || "").toLowerCase();
  if (!text.includes(PFM_NODE_REPORT_EXPLORATION_NEEDED_MSG.toLowerCase())) return false;
  const hasFeaturesBlock =
    /\bmain\s+features\b/.test(text) ||
    /#{1,4}\s*main\s+features\b/.test(text) ||
    /\bfeature\s+\d+:/.test(text) ||
    /\btest\s+case\b/.test(text) ||
    /procedure\s+steps/.test(text);
  return !hasFeaturesBlock;
}
